var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "feature-2"
  }, [_c('div', {
    staticClass: "field-icon"
  }, [_c('img', {
    attrs: {
      "src": _vm.feature.image,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "field-box-title heading-3-bold",
    domProps: {
      "innerHTML": _vm._s(_vm.feature.title)
    }
  }), _c('div', {
    staticClass: "field-box-title paragraph-1-large",
    domProps: {
      "innerHTML": _vm._s(_vm.feature.subTitle)
    }
  }), _c('div', {
    staticClass: "button-container"
  }, [_c('seu-button', {
    attrs: {
      "label": _vm.feature.buttonLabel,
      "button-link": _vm.feature.buttonLink,
      "button-icon-before": _vm.feature.buttonIcon
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }